import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const EUROPEAN_COUNTRIES = new Set([
  'Albania', 'Andorra', 'Austria', 'Belgium',
  'Bosnia and Herzegovina', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic',
  'Czechia', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany',
  'Greece', 'Hungary', 'Iceland', 'Ireland', 'Italy', 'Kosovo',
  'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Malta',
  'Monaco', 'Montenegro', 'Netherlands', 'North Macedonia', 'Norway', 'Poland',
  'Portugal', 'Romania', 'San Marino', 'Serbia', 'Slovakia', 'Slovenia',
  'Spain', 'Sweden', 'Switzerland', 'Turkey', 'Ukraine', 'United Kingdom',
  'Vatican City',
]);

const CACHE_KEY = 'geo_region';

interface GeoRegion {
  isEurope: boolean;
  country: string | null;
  loading: boolean;
}

export const useGeoRegion = (): GeoRegion => {
  const [state, setState] = useState<GeoRegion>(() => {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        return { isEurope: parsed.isEurope, country: parsed.country, loading: false };
      } catch { /* ignore */ }
    }
    return { isEurope: true, country: null, loading: true }; // default to Europe while loading
  });

  useEffect(() => {
    if (!state.loading) return;

    supabase.functions.invoke('geo-lookup').then(({ data }) => {
      const country = data?.country || null;
      const isEurope = country ? EUROPEAN_COUNTRIES.has(country) : true; // default EU if unknown
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ isEurope, country }));
      setState({ isEurope, country, loading: false });
    }).catch(() => {
      setState({ isEurope: true, country: null, loading: false });
    });
  }, [state.loading]);

  return state;
};
